import React, { useState, useEffect } from 'react';
import { Card, CardContent, Divider } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import { mapFieldValues } from '../plagins/utility';
import { useSelector } from 'react-redux';
import Header from './areaGrave/Header';
import GraveDetail from './GraveDetail'; // כאן הגדרת הקומפוננטה החסרה
import { useContext } from 'react';
import { GlobalContext } from '../../../App';
import DraggableList from '../pagesTesting/handleToggleExpand';
import ConfirmationDialog from '../plagins/dialogs/ConfirmationDialog';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { createFetchDataServer } from '../../../database/fetchData';
import ImageGraveDetiles from './areaGrave/ImageGraveDetiles';

const AreaGraveDetail = () => {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const properties = useSelector((state) => state.columnsPropertiesAreaGraves.data);
  // טעינת היוזים לפונקציות עזר
  const { removeAreaGrave } = useQueries();

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, breadcrumbs, setTitle, permission } = useContext(GlobalContext);

  const [loading, setLoading] = useState(true); // מצב טעינה

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};
  const [myAreaGrave, setMyAreaGrave] = useState(context?.contextAreaGraves?.find((areaGrave) => areaGrave?.unicId === value?.unicId) || value);
  useEffect(() => {
    context?.contextAreaGraves?.length > 0 && context?.contextGraves?.length > 0 && setLoading(false);
    setMyAreaGrave(context?.contextAreaGraves?.find((areaGrave) => areaGrave?.unicId === value?.unicId) || value);
  }, [context]);

  useEffect(() => {
    setTotalWidthContainer(1800);

    const pathSegments = location.pathname.split('/').filter(Boolean); // חילוץ המקטעים מה-URL

    // ביצוע פעולות על פי המקטעים
    if (pathSegments.length > 0) {
      const subSegments = pathSegments.slice(1); // לדוגמה, ['4', '3', '2']

      let temp = breadcrumbs;
      // שמירת האיברים הראשונים עד לאורך של subSegments
      temp = temp.slice(0, subSegments.length);
      temp = [
        ...temp,
        {
          id: (temp.length > 0 ? temp[temp.length - 1].id : 0) + 1,
          name: `אחוזת קבר ${myAreaGrave?.areaGraveNameHe}`,
          url: location.pathname,
          state: location.state
        }
      ];

      setBreadcrumbs(temp);
      setTitle(`אחוזת קבר ${myAreaGrave?.areaGraveNameHe}`);
    }
  }, [context, location.pathname]);

  // בניית השדות לתצוגה
  const [columns, setColumns] = useState([]);
  useEffect(() => {
    setColumns(properties?.filter((prop) => prop?.show)?.map((prop) => ({ id: prop?.id, name: prop?.field, title: prop?.headerName, value: myAreaGrave[prop?.field] || '' })));
  }, [properties]);

  const [mappedFloors, setMappedFloors] = useState([]); // הגדרת mappedFloors כ־state

  useEffect(() => {
    const updatedMappedFloors = mapFieldValues(
      context?.contextGraves?.filter((grave) => grave.areaGraveId === myAreaGrave?.unicId),
      optionsFields
    )?.sort((a, b) => (a.graveNameHe < b.graveNameHe ? -1 : a.graveNameHe > b.graveNameHe ? 1 : 0));

    setMappedFloors(updatedMappedFloors);
  }, [optionsFields, myAreaGrave?.unicId, context]);

  // **************  מחיקה  ****************

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  // הסרת אחוזת קבר
  const deleteItem = () => {
    let gravesChaild = context?.contextGraves?.filter((grave) => grave.areaGraveId === myAreaGrave.unicId).filter((grave) => grave.graveStatus !== 1);
    if (gravesChaild?.length > 0) {
      alert('לא ניתן להסיר, קיים תיק מקושר');
    } else {
      setOpenConfirmDialog(true);
    }
  };

  useEffect(() => {
    fetchDataServer(['graves', 'signatures'], token, 20000);
  }, []);

  const nameWithTime = `${myAreaGrave?.areaGraveNameHe}-${myAreaGrave?.plotNameHe}-${myAreaGrave?.blockNameHe}`;

  if (loading) return <LoadingOverlay />;

  return (
    <Card raised style={{ background: '#f8f9fa' }}>
      <CardContent>
        <Header columns={columns} value={myAreaGrave} handleButtonUpdate={() => navigate('/areaGraveUpdate', { state: { value: myAreaGrave } })} handleDelete={deleteItem} />       
        <ImageGraveDetiles 
        image={`https://mbe-plus.com/kadishaV1/vaadma/gravesImages/${nameWithTime}.jpg`}
        imageName={nameWithTime} columns={columns} />

        <Divider sx={{ marginTop: '15px', marginBottom: 0, width: '100%', height: '0.5px', bgcolor: 'grey.700', boxShadow: '0px 0px 4px 4px rgba(0,0,0,0.3)' }} />
        <DraggableList
          items={mappedFloors?.map((grave, index) => ({
            id: index,
            name: `קבר : ${grave?.graveNameHe}`,
            status: grave?.graveStatus,
            description: <GraveDetail key={index} grave={grave} />
          }))}
        />
      </CardContent>

      {/* דיאלוג לאישור מחיקה */}
      <ConfirmationDialog
        open={openConfirmDialog}
        title="אישור מחיקה"
        content="האם את/ה בטוח שברצונך להסיר את אחוזת הקבר?"
        onAnswer={(answer) => {
          setOpenConfirmDialog(false);
          if (answer) {
            removeAreaGrave({ id: myAreaGrave?.unicId });

            context?.setContextAreaGraves((prev) => {
              // מציאת הפריט שצריך להסיר
              const removedItem = prev.find((item) => item.unicId === myAreaGrave?.unicId);

              // הוספת הפריט ל-setTempAreaGraves אם נמצא
              if (removedItem) {
                let temp = JSON.parse(localStorage.getItem('tempRemoveItem')) || [];
                localStorage.setItem('tempRemoveItem', JSON.stringify([...temp, removedItem]));
              }

              // החזרת הרשימה החדשה ללא הפריט שהוסר
              return prev.filter((item) => item.unicId !== myAreaGrave?.unicId);
            });

            context?.setContextGraves((prev) => {
              // מציאת האייטמים שצריך להסיר
              const itemsToRemove = prev.filter((item) => context?.contextGraves?.filter((grave) => grave.areaGraveId === myAreaGrave.unicId)?.some((grave) => grave.unicId === item.unicId));

              // החזרת הרשימה החדשה ללא האייטמים שהוסרו
              return prev.filter((item) => !context?.contextGraves?.filter((grave) => grave.areaGraveId === myAreaGrave.unicId)?.some((grave) => grave.unicId === item.unicId));
            });

            navigate(-1);
          }
        }}
      />
    </Card>
  );
};

export default AreaGraveDetail;
